<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="时间段" prop="timeRange">
            <el-date-picker
                v-model="queryForm.timeRange"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
               :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="用户类型" prop="usertype">
            <el-select v-model="queryForm.usertype" clearable placeholder="请选择用户类型">
              <el-option
                  v-for="item in userTypes"
                  :key="item"
                  :label="item"
                  :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8" :offset="2">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="exportCashOutReport()" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="ID" label="序号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="cashOutMoneyDate" label="提现日期" />
      <el-table-column prop="dayCashOutMoney" label="提现金额" />
      <el-table-column prop="remarks" label="备注" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryCashOutMoneyDayData} from "../../api/b2cbusiness/b2c_admin";
import qs from "qs";
export default {
  name: "CashOutReports",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
        usertype: '',
        timeRange:[],
      },
      userTypes:[
          "业务员",
          "试客",
          "主播",
          "商家"
      ],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.getPassYearFormatDate();
    this.getData();
  },
  methods: {
    exportCashOutReport(){
      window.open("https://api.weiquanai.com/b2cadmindatacharts/exportcashmoney?"+qs.stringify({
        userType:this.queryForm.usertype,
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1
      }), "_blank");
    },
    getData(){
      if (this.queryForm.timeRange.length <= 0){
        this.queryForm.timeRange = this.tmpRange;
        console.log(this.queryForm, this.tmpRange)
      }
      queryCashOutMoneyDayData(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getPassYearFormatDate () {
      let nowDate = new Date()
      let date = new Date(nowDate)
      date.setDate(date.getDate() - 5)
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let formatDate = year + seperator1 + month + seperator1 + strDate + " 00:"+ "00:"+ "00"
      this.getNowFormatDate(formatDate)
    },
    getNowFormatDate (formatDate) {
      let date = new Date()
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let nowData = year + seperator1 + month + seperator1 + strDate + " 23:"+ "59:"+ "59";
      this.tmpRange= [formatDate, nowData] ;
      //console.log(this.queryForm)
      this.$forceUpdate();
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
